<template>
                <div class="area">
                <article>
                    <h5>Seleccione Convocatoria</h5>
                    <hr />               
                    <section class="row">
                        <section class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6 style="padding: 5px">Convocatoria</h6>   
                        <CSelectGenerico 
                        v-on:valorParaElPadre="cambioSubSeccion"  
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'Convocatorias1'" 
                        :valorDefinido="-1" 
                        :elementos="opciones" 
                        :mansajeValorDefinidoSingular="'Convocatoria'">
                       </CSelectGenerico>
                       </section>

                       <section class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3" v-if="filtro.convocatoria > 0">
                        <h6 style="padding: 5px">Categoria</h6>   
                        <CSelectGenerico 
                        v-on:valorParaElPadre="cambioCategoria"  
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'Categoria1'" 
                        :valorDefinido="-1" 
                        :elementos="categorias" 
                        :mansajeValorDefinidoSingular="'Categoria'">
                       </CSelectGenerico>
                       </section>

                       <section class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6 style="padding: 5px">Estado del Aspirane</h6>   
                        <CSelectGenerico 
                        v-on:valorParaElPadre="cambioEstado"  
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'Estado1'" 
                        :valorDefinido="-1" 
                        :elementos="estados" 
                        :mansajeValorDefinidoSingular="'Estado'">
                       </CSelectGenerico>
                       </section>
                    <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <button style="margin-top: 31px;"  type="button" class="btn btn-primary ml-2" @click="ObtenerFiltros"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                   </div>
                    </section>
                    <div >
                        <hr />
                        <div class="text-right" style="margin-top: 20px;">                         
                             <div class="d-flex justify-content-end mt-4">
                     </div> 
                        </div> 
                    </div>
                </article>
            </div>
      
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import comun from "@/../static/js/comun"

  export default {
    data() {
        return{
            opciones:[{valor:1,nombre:"Valor Uno"}],
            estados:[{valor:1,nombre:"Valor Uno"}],
            categorias:[{valor:1,nombre:"Valor Uno"}],
            enumeraciones,
            filtro:{
                convocatoria:0,
                estado:0,
                categoria:0
            }

        }
        
    },
    components:{
        CSelectGenerico
    },
    methods:{
        cambioSubSeccion:async function(parametro,parametroDos){
            await Promise.resolve( this.filtro.convocatoria = parametro.target.value);
            if(this.filtro.convocatoria <= 0)this.filtro.categoria=0;
            this.obtenerCategorias(); 
        },
        cambioEstado:async function(parametro,parametroDos){
           
            console.log("parametroDos::::",parametro)
            await Promise.resolve( this.filtro.estado =  parametro.target.value); 
        },
        cambioCategoria:async function(parametro,parametroDos){
           
           console.log("parametroDos::::",parametro)
           await Promise.resolve( this.filtro.categoria =  parametro.target.value); 
       },

        ObtenerFiltros:function() {
            this.$emit("MetodoPadre",this.filtro);

        },

        obtenerConvocatorias: async function(){
            const METODO_API_CONVOCATORIAS = api.convocatorias.sistema.ObtenerTitulosConvocatorias;
            axios.get(api.conexion + METODO_API_CONVOCATORIAS).then(respuesta => {
                console.log("RESPUESTA ",respuesta)    
                comun.SeEstaCargandoInformacion(false);
                   
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.opciones = respuesta.data.titulos                   
                    }
                }).catch(excepcion => {
                    console.log("error",excepcion);
                    comun.SeEstaCargandoInformacion(false);                   
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });

        },
        obtenerEstados: async function(){
            const METODO_API_ESTADOS_ASPIRANTES = api.conexion+api.convocatorias.sistema.ObtenerEstadosConvocatorias+"?activo=true=&registrosParaOmitir="+3;
                axios.get(METODO_API_ESTADOS_ASPIRANTES).then(respuesta => {
                console.log("RESPUESTA ",respuesta)    
                comun.SeEstaCargandoInformacion(false);
                   
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.estados = respuesta.data.Estados                   
                    }
                }).catch(excepcion => {
                    console.log("error",excepcion);
                    comun.SeEstaCargandoInformacion(false);                   
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });

        },
        obtenerCategorias: async function(){
            const METODO_API_CATEGORIAS = api.conexion+api.convocatorias.sistema.ObtenerCategorias+"?idCall="+this.filtro.convocatoria;
                axios.get(METODO_API_CATEGORIAS).then(respuesta => {
                console.log("RESPUESTA categoria ",respuesta)    
                comun.SeEstaCargandoInformacion(false);
                   
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.categorias = respuesta.data.Categorys.map(mp =>                        
                        {
                            let elementoFormateado = mp;
                            elementoFormateado.valor = mp.IdCategory;
                            elementoFormateado.nombre = mp. CategoryName;
                            return elementoFormateado;
                        }) 
                        console.log("RESPUESTA categoria ", this.categorias)                  
                    }
                }).catch(excepcion => {
                    console.log("error",excepcion);
                    comun.SeEstaCargandoInformacion(false);                   
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });

        },

    },
    mounted(){
        this.obtenerConvocatorias();
        this.obtenerEstados();
      //  this.obtenerCategorias();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/AdministradorConvocatorias/ConsultaConvocatorias/FiltroConvocatorias.vue